import { __assign } from "tslib";
import { VeltService } from './velt';
var StoreService = /** @class */ (function () {
    function StoreService(plugin) {
        var _this = this;
        this.isSubscribed = false;
        this.globalStore = {
            editor: null,
            comments: [],
            filteredComments: [],
            selectedCommentsMap: new Map(),
        };
        // Global annotation storage
        this.globalAnnotationStore = new Map();
        /**
         * Helper to get and set annotations with debug messages
         */
        this.annotationStore = {
            get: function (id) {
                return _this.globalAnnotationStore.get(id);
            },
            set: function (id, data) {
                _this.globalAnnotationStore.set(id, data);
            },
            getAll: function () {
                return new Map(_this.globalAnnotationStore);
            },
            clear: function () {
                _this.globalAnnotationStore.clear();
            },
            remove: function (id) {
                _this.globalAnnotationStore.delete(id);
            },
            hasAnnotationTextChanged: function (annotationId, currentAnnotation) {
                var _a, _b;
                try {
                    var storedData = _this.globalAnnotationStore.get(annotationId);
                    if (!storedData || !currentAnnotation)
                        return false;
                    var storedText = storedData.annotation.text;
                    var currentText = (_b = (_a = currentAnnotation.context) === null || _a === void 0 ? void 0 : _a.textEditorConfig) === null || _b === void 0 ? void 0 : _b.text;
                    return storedText !== currentText;
                }
                catch (error) {
                    return false;
                }
            },
        };
        this.updateGlobalStore = function (store) {
            var _a, _b, _c;
            try {
                var comments = (store === null || store === void 0 ? void 0 : store.comments) || ((_a = _this.globalStore) === null || _a === void 0 ? void 0 : _a.comments) || [];
                var newSelectedCommentsMap_1 = (store === null || store === void 0 ? void 0 : store.selectedCommentsMap) || ((_b = _this.globalStore) === null || _b === void 0 ? void 0 : _b.selectedCommentsMap) || new Map();
                var oldFilteredComments = ((_c = _this.globalStore) === null || _c === void 0 ? void 0 : _c.filteredComments) || [];
                var filteredComments = comments.filter(function (annotation) {
                    var _a;
                    return (((_a = annotation === null || annotation === void 0 ? void 0 : annotation.status) === null || _a === void 0 ? void 0 : _a.type) !== 'terminal' ||
                        (newSelectedCommentsMap_1 === null || newSelectedCommentsMap_1 === void 0 ? void 0 : newSelectedCommentsMap_1.get(annotation === null || annotation === void 0 ? void 0 : annotation.annotationId)));
                });
                // Create a Set of new annotation IDs for O(1) lookup
                var newAnnotationIds_1 = new Set(filteredComments.map(function (annotation) { return annotation === null || annotation === void 0 ? void 0 : annotation.annotationId; }));
                // Get IDs of removed comments
                var removedAnnotationIds = oldFilteredComments
                    .map(function (annotation) { return annotation === null || annotation === void 0 ? void 0 : annotation.annotationId; })
                    .filter(function (id) { return id && !newAnnotationIds_1.has(id); });
                // Remove comments from editor using just IDs
                removedAnnotationIds.forEach(function (annotationId) {
                    var _a, _b;
                    if (((_a = _this.globalStore) === null || _a === void 0 ? void 0 : _a.editor) && annotationId) {
                        _this.plugin.editorService.removeVeltCommentFromEditor((_b = _this.globalStore) === null || _b === void 0 ? void 0 : _b.editor, annotationId);
                    }
                });
                _this.globalStore = __assign(__assign(__assign({}, _this.globalStore), store), { filteredComments: filteredComments });
                _this.highlightCommentsFromGlobalStore();
            }
            catch (error) {
                // handle error
                VeltService.catchError('Error updating global store:', error);
            }
        };
        this.highlightCommentsFromGlobalStore = function () {
            var _a, _b, _c, _d, _e, _f;
            try {
                var _g = _this.globalStore, editor = _g.editor, filteredComments = _g.filteredComments;
                if (!editor || !filteredComments)
                    return;
                for (var _i = 0, filteredComments_1 = filteredComments; _i < filteredComments_1.length; _i++) {
                    var annotation = filteredComments_1[_i];
                    var textToFind = (_b = (_a = annotation === null || annotation === void 0 ? void 0 : annotation.context) === null || _a === void 0 ? void 0 : _a.textEditorConfig) === null || _b === void 0 ? void 0 : _b.text;
                    var occurrence = (_d = (_c = annotation === null || annotation === void 0 ? void 0 : annotation.context) === null || _c === void 0 ? void 0 : _c.textEditorConfig) === null || _d === void 0 ? void 0 : _d.occurrence;
                    if (textToFind) {
                        _this.plugin.editorService.highlightTextWithVeltComment(editor, textToFind, {
                            annotationId: annotation === null || annotation === void 0 ? void 0 : annotation.annotationId,
                            multiThreadAnnotationId: annotation === null || annotation === void 0 ? void 0 : annotation.multiThreadAnnotationId,
                            occurrence: occurrence,
                            targetTextNodeId: (_f = (_e = annotation === null || annotation === void 0 ? void 0 : annotation.context) === null || _e === void 0 ? void 0 : _e.textEditorConfig) === null || _f === void 0 ? void 0 : _f.targetTextNodeId,
                            originalAnnotation: annotation, // Pass the complete annotation object
                        });
                    }
                }
            }
            catch (error) {
                // handle error
                VeltService.catchError('Error highlighting comments from global store:', error);
            }
        };
        this.plugin = plugin;
        try {
            VeltService.subscribeToSelectedCommentsMap(this.plugin.editorId, function (selectedCommentsMap) {
                try {
                    _this.updateGlobalStore({ selectedCommentsMap: selectedCommentsMap });
                }
                catch (error) {
                    VeltService.catchError('Error updating global store:', error);
                }
            });
        }
        catch (error) {
            VeltService.catchError('Error subscribing to selected comments map:', error);
        }
    }
    StoreService.storeInstanceMap = new Map();
    return StoreService;
}());
export { StoreService };
